import { Injectable } from "@angular/core";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { Observable, throwError } from "rxjs";
import { OpenBrowserUrlRepo } from "@app/core/open-browser-url/domain/open-browser-url.repo";

@Injectable({ providedIn: "root" })
export class OpenBrowserUrlUseCase {
  constructor(private openBrowserUrlRepo: OpenBrowserUrlRepo) {}

  execute(url: string) {
    return this.openBrowserUrlRepo.open(url);
  }
}
